import * as Store from '@apply/store';
import { Question, QuestionType, PageQuestionProps, Legend } from '@apply/ui';
import { connect } from 'react-redux';

export interface ContactInformationPageQuestionProps extends PageQuestionProps {
    onChangeName: (guid: string, value: string) => void;
    onChangeEmail: (guid: string, value: string) => void;
    onChangePhone: (guid: string, value: string) => void;
}

const ContactInformation: React.FC<ContactInformationPageQuestionProps> = ({
    onQuestionValidate,
    submitted,
    property,
    onChangeName,
    onChangeEmail,
    onChangePhone,
}) => {
    return (
        <div className='form-group visual-group'>
            <fieldset>
                <Legend>Property Contact Information</Legend>
                <div className='row'>
                    <div className='columns small-12 medium-4'>
                        <Question
                            type={QuestionType.Text}
                            submitted={submitted}
                            selector='nonRentalName'
                            placeholder='John Smith'
                            styleName='grouped'
                            value={property.nonRental?.name || ''}
                            onQuestionValidate={onQuestionValidate}
                            onChangeQualifier={property.guid}
                            onChange={onChangeName}
                            required={true}
                        >
                            <span className='sr-only'>Contact</span> Name
                        </Question>
                    </div>
                    <div className='columns small-12 medium-4'>
                        <Question
                            type={QuestionType.Email}
                            submitted={submitted}
                            selector='nonRentalEmail'
                            placeholder='jsmith@gmail.com'
                            styleName='grouped'
                            value={property.nonRental?.email || ''}
                            onQuestionValidate={onQuestionValidate}
                            onChangeQualifier={property.guid}
                            onChange={onChangeEmail}
                            required={true}
                        >
                            <span className='sr-only'>Contact</span> Email
                        </Question>
                    </div>
                    <div className='columns small-12 medium-4'>
                        <Question
                            type={QuestionType.Phone}
                            submitted={submitted}
                            selector='nonRentalPhone'
                            placeholder='(212) 555-1212'
                            styleName='grouped'
                            value={property.nonRental?.phone}
                            onChangeQualifier={property.guid}
                            onChange={onChangePhone}
                        >
                            <span className='sr-only'>Contact</span> Mobile Phone
                        </Question>
                    </div>
                </div>
            </fieldset>
        </div>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
    };
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: {
        onChangeName: (guid: string, value: string) => void;
        onChangeEmail: (guid: string, value: string) => void;
        onChangePhone: (guid: string, value: string) => void;
        dispatch: Store.ApplyDispatchType;
    } = {
        onChangeName: (guid: string, value: string) => dispatch(Store.PropertiesStore.Actions.updateNonRentalName(guid, value)),
        onChangeEmail: (guid: string, value: string) => dispatch(Store.PropertiesStore.Actions.updateNonRentalEmail(guid, value)),
        onChangePhone: (guid: string, value: string) => dispatch(Store.PropertiesStore.Actions.updateNonRentalPhone(guid, value)),
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactInformation);
